import styled from 'styled-components';

import { rgba, size } from '../../layout/helpers';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  padding-top: ${size(5)};
`;

export const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size(0.5)};
  margin-top: ${size(4)};
  padding: ${size(2)} ${size(3)};
  border-radius: 10px;
  background-color: ${(props) => rgba(props.theme.color.ui.error, 0.1)};
  color: ${(props) => props.theme.color.brand.primary.secondary};
`;

export const SignOutWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  padding-top: ${size(3)};
`;
